import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";

const FileNameCard = ({
                          fileName,
                          defaultTemplate = "Default",
                      }) => {
    return (
        <Tooltip title={fileName}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                sx={{
                    minHeight: 48,
                }}
            >
                <Typography
                    variant="body1"
                    noWrap
                    sx={{
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "15px",
                        color: "primary", // Primary text
                        letterSpacing: "-0.01em",
                    }}
                >
                    {fileName}
                </Typography>
                <Typography
                    variant="body2"
                    noWrap
                    sx={{
                        mt: 0.25,
                        fontSize: "12px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "#718096",
                        letterSpacing: 0,
                    }}
                >
                    {`${defaultTemplate}`}
                </Typography>
            </Box>
        </Tooltip>

    );
};

export default FileNameCard;